import { useAppTranslation } from "@/utils";
import { Button, CardList, Space, Tag, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { InfoCircleOutlined, Warning } from "@payping/icons";
import { DisplayModeEnum, ListCardProps } from "@payping/web-components/components/List/types";
import { PagedQueryResultRequestDetailsVM, RequestStatusEnum, requestApis } from "@payping/api";

import { DashboardRoutes } from "@/router";
import { useNavigate } from "react-router-dom";
import { FC } from "react";

interface Props {
  value?: PagedQueryResultRequestDetailsVM;
  retryStatus: () => void;
  retryList: () => void;
}
const UnknownAlert: FC<Props> = ({ value, retryList, retryStatus }) => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();

  const [{ loading }, onSubmit] = useMessagedAsyncFn(async () => {
    const inquireUnknown = await requestApis.inquireUnknownRequestStatusWithRequestWithCancellationTokenPost({
      requestCode: value?.data?.[0].code,
    });
    if (inquireUnknown.newStatus !== RequestStatusEnum.Unknown) {
      retryList();
      retryStatus();
    }
  }, []);

  const data: ListCardProps["dataSource"] =
    value?.data?.map((settlement) => ({
      actions: [
        <Button
          type={"link"}
          key={1}
          onClick={() => {
            navigate({
              pathname: DashboardRoutes.settlement.report.detail.url.replace(":code", settlement.code || ""),
            });
          }}
        >
          {t("common.detail")}
        </Button>,
        <Button loading={loading} onClick={onSubmit} key={2} type={"primary"}>
          {t("inquiry")}
        </Button>,
      ],
      descriptions: <Typography.Text>{settlement?.code}</Typography.Text>,
      content: [
        <Space key={1}>
          <Typography.Text type={"secondary"}>{t("settlement.numberOfPayments")}</Typography.Text>
          <Typography.Text>
            {(settlement?.succeededCount || 0) + (settlement?.failedCount || 0) + (settlement?.inProgressCount || 0)}
          </Typography.Text>
        </Space>,
      ],
      title: {
        primary: settlement.title,
        secondary: <Tag color={"orange"}>{t(`settlement.request.status.Unknown`)}</Tag>,
      },
      key: settlement.code || "",
    })) || [];
  return (
    <>
      {value?.data?.length ? (
        <Space direction={"vertical"} size={"middle"} className={"tw-w-full"}>
          <Space>
            <Warning width={14} />
            <Typography.Text strong>{t("settlement.error.errorPreviousWithdraw")}</Typography.Text>
          </Space>
          <CardList dataSource={data} mode={DisplayModeEnum.List} />
          <Space>
            <InfoCircleOutlined color={"gray"} width={14} />
            <Typography.Text type={"secondary"}>{t("settlement.error.unknownDesc")}</Typography.Text>
          </Space>
        </Space>
      ) : null}
    </>
  );
};

export default UnknownAlert;
